module.exports = __webpack_public_path__ + "static/media/dedicated.523a0f56.png";